import { Routes } from '@angular/router';

import { AuthGuard } from '../../../guards/auth.guard';
import { DashboardComponent } from './dashboard.component';

export const dashboardRoutes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: DashboardComponent
  }
];
